/* eslint-disable */
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['standardPanel', 'textPanel', 'standardTab', 'textTab', 'modeInput']
  static values = { initialMode: String, textDisabled: Boolean }

  connect() {
    this.currentMode = this.initialModeValue === 'text' ? 'text' : 'standard';
    this._applyMode(this.currentMode);

    if (this.textDisabledValue) {
      // is_listed_on_flie の場合はテキストタブを無効化し、address_mode を強制的に standard にする
      this.textTabTarget.classList.add('is-disabled');
      this.textTabTarget.dataset.tooltip = 'FLIE掲載物件では選択不可';
      this.currentMode = 'standard';
      this.modeInputTarget.value = 'standard';
      this._applyMode('standard');
    }
  }

  selectStandard(event) {
    event.preventDefault();
    this.currentMode = 'standard';
    this.modeInputTarget.value = 'standard';
    this._applyMode('standard');
  }

  selectText(event) {
    event.preventDefault();
    // is_listed_on_flie の場合はテキストタブへの切り替えを禁止
    if (this.textDisabledValue) return;
    this.currentMode = 'text';
    this.modeInputTarget.value = 'text';
    this._applyMode('text');
  }

  _applyMode(mode) {
    const isStandard = mode === 'standard';

    // タブのactive状態を切り替え
    this.standardTabTarget.classList.toggle('is-active', isStandard);
    this.textTabTarget.classList.toggle('is-active', !isStandard);

    // パネルの表示切り替え
    this.standardPanelTarget.style.display = isStandard ? '' : 'none';
    this.textPanelTarget.style.display = isStandard ? 'none' : '';
  }
}
